import { createStore } from "owa-satcheljs";
import type { ExtendedTheme } from "./schema/ExtendedTheme";

const initialStore: ExtendedTheme = {
    densityMode: "Full",
    palette: undefined,
    fonts: undefined,
    isInverted: false,
    density: undefined,
};

const defaultExport: () => ExtendedTheme = createStore<ExtendedTheme>("fabricTheme", initialStore);
export default defaultExport;
